export const DISABLED_NOTIFICATION_PAGES_IDS = ['play2learn-zoom'];
